import React from 'react';

import Code from './Code';

export default {
  code: Code,
  pre: preProps => <pre {...preProps} />,
};
